module.exports = __webpack_public_path__ + "img/adv_icon3.d4571d37.png";